<div class="modal fade" id="staticErrorBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticErrorBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            @if(this.dialogService.title) {
            <div class="modal-header" id="dialogue-header">
                <h4 class="modal-title" id="dialogue-title"> {{ this.dialogService.title }} </h4>
            </div>
            }
            <div class="modal-body" id="error-message">
                {{ this.dialogService.message }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn--confirm" id="btn-ok" data-bs-dismiss="modal"
                    data-bs-dismiss="modal" (click)="this.dialogService.closeDialog()">U
                    redu</button>
            </div>
        </div>
    </div>
</div>